import './index.scss'

const tpl = `
  <div class="comment-model">
      <div class="comment-model-content">
          <div class="hd">
              <span class="btn cancel">取消</span>
              <span class="title">留言</span>
              <span class="btn send">发表</span>
          </div>
          <div class="bd">
              <textarea id="comment-model-textarea" placeholder="写下你的想法"></textarea>
          </div>
      </div>
  </div>
`

class Model {
  constructor(options = {}) {
    this.addCommentModel()
    this.opts = Object.assign(
      {
        openBtn: document.querySelector('.comment-puppet .input'),
        send() {}
      },
      options
    )
    this.openBtn = this.opts.openBtn
    this.model = document.querySelector('.comment-model')
    this.input = document.querySelector('#comment-model-textarea')
    // this.init()
  }
  addCommentModel() {
    document.querySelector('.container').innerHTML += tpl
  }
  init() {
    const { openBtn, model, input, toggle, send } = this
    openBtn.addEventListener('click', toggle.bind(this, true))
    model
      .querySelector('.cancel')
      .addEventListener('click', toggle.bind(this, false))
    input.addEventListener(
      'focus',
      setTimeout.bind(null, window.scrollTo.bind(null, 0, 99999), 500)
    )
    input.addEventListener('keyup', () => {
      const val = input.value
      model.classList[!!val ? 'add' : 'remove']('inputed')
    })
    model.querySelector('.send').addEventListener('click', send.bind(this))
  }
  toggle(bool) {
    const { model, input } = this
    model.classList[bool ? 'add' : 'remove']('show')
    document
      .querySelector('body')
      .classList[bool ? 'add' : 'remove']('show-comment')

    input[bool ? 'focus' : 'blur']()
  }
  send() {
    const { model, input } = this
    const value = input.value
    if (!value) {
      input.blur()
      window.toast('请输入内容')
      return
    }
    this.opts.send(value, () => {
      this.input.value = ''
      this.toggle(false)
    })
  }
}

export default Model



// WEBPACK FOOTER //
// ./src/page-resource/lesson/compoents/commentModel/index.js